import React from "react";
import Web from "../images/contenido/Culturadigitalpe.jpg";
import Debate from "../images/contenido/CulturaDigitalDebate.jpg";
import SandroMarcone from "../images/contenido/SandroMarcone.jpg";
import Navigation from "../components/Navigation";
import { Helmet } from "react-helmet";

const CulturaDigital = () => {
  return (
    <section className="nosotros talleres">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Sociedad de la información y cultura digital para la ciudadanía -
          Memoria 2014-2024 - Fundación Gustavo Mohme Llona
        </title>
        <meta
          property="og:title"
          content="Sociedad de la información y cultura digital para la ciudadanía - Memoria 2014-2024 - Fundación Gustavo Mohme Llona"
        />
      </Helmet>

      <div id="gustavo-mohme-llona" className="bg-white">
        <div className="container d-flex header-page">
          <div className="column-0">
            <div className="pre-title">2.3</div>
            <h1 className="color-blue title-small">
              Sociedad de la información y cultura digital para la ciudadanía
            </h1>
          </div>
          <div className="column-0">
            <div className="cont-mohme-0">
              <img
                src={Web}
                alt="Portal culturadigital.pe"
                className="mohme-0 border-img"
              />
              <div className="legend">
                El proyecto contempló la puesta en línea del portal
                culturadigital.pe, concebido como un espacio de consultas e
                intercambio de recursos para informar y reflexionar sobre la
                sociedad de información, la tecnología y la cultura digital en
                el Perú y, de esa manera, contribuir al desarrollo de la
                ciudadanía.
              </div>
              <div className="block-blue"></div>
            </div>
            <div className="block-blue-light"></div>
          </div>
        </div>
        <div className="container">
          <div className="container-text">
            <p>
              Iniciativa impulsada en alianza con el Instituto para la Sociedad
              de la Información (IPSI) y la Universidad Antonio Ruiz de Montoya
              (UARM). Su objetivo fue contribuir a formar opinión pública en
              torno a la cultura digital como medio para fortalecer la
              ciudadanía y promover su ejercicio en espacios alternativos. En
              esta línea, generó espacios de análisis y reflexión orientados a
              impulsar la reflexión y líneas de investigación académica y
              suscitar interés en decisores de políticas públicas.
            </p>
            <figure className="img-left img-m">
              <div className="block-blue-light"></div>
              <img
                src={SandroMarcone}
                alt="Paul Maquet y Virna Valdivia"
                className="img-m"
              />
              <div className="legend">
                Firma del convenio con Sandro Marcone (IPSI).
              </div>
            </figure>
            <h4>
              2.3.1 MESA DE DEBATE 1: ECONOMÍA DE LA INFORMACIÓN Y SOCIEDAD RED
            </h4>
            <p>
              Se realizó el 23 de junio del 2016 en la Universidad Antonio Ruiz
              de Montoya (UARM). Se trató de un primer espacio para reflexionar
              en torno a la configuración, la implementación y el gobierno de
              una sociedad en la que el flujo irrestricto de la información y el
              conocimiento estén al servicio del bien común, así como de la
              necesidad de promover una sociedad que apunte a la centralidad y
              empoderamiento de sus ciudadanos, para que estos puedan
              desarrollarse y encuentren posibilidades de incrementar su
              bienestar en el uso adecuado y eficaz de las TIC. En la primera
              mesa, "Economía de la Información", participaron Jorge Copello,
              Roxana Bravo, Ricardo Villanueva y Roberto Bustamante. En la
              segunda, "Sociedad Red", estuvieron presentes Teresa Quiroz, Laura
              León, Miguel Morachimo, Julio César Matheus.
            </p>

            <div className="quote quote-center quote-blue">
              <p>
                Por una sociedad en la que el flujo irrestricto de la
                información y el conocimiento estén al servicio del bien común.
              </p>
            </div>
            <figure className="img-center">
              <div className="block-blue-light"></div>
              <img
                src={Debate}
                alt="Paul Maquet y Virna Valdivia"
                className=""
              />
              <div className="legend">
                Jorge Copello, Roxana Bravo, Ricardo Villanueva y Roberto
                Bustamante en la primera mesa de debate organizada como parte
                del proyecto culturadigital.pe
              </div>
            </figure>
            <h5>
              2.3.2 MESA DE DEBATE 2: SOCIEDAD DE LA INFORMACIÓN, EDUCACIÓN Y
              CIUDADANÍA
            </h5>
            <p>
              Se realizó el 7 de octubre del 2016 en la Universidad Antonio Ruiz
              de Montoya (UARM). Se organizó en distintos paneles. El primero
              tuvo como título “Educación & sociedad red” y contó con la
              presencia de Sandro Marcone Flores, Patricia Salas, Fernando
              Villarán y la moderación de Roberto Rojas. El segundo fue
              “Ciudadanía en la era de la información” y contó con la
              participación de Jorge Bossio, Sandro Venturo, José Alejandro
              Godoy y la moderación de Karen Puertas. Finalmente, se presentó la
              mesa “Pedagogía y cultura digital”, que tuvo como ponente al Dr.
              Cristóbal Suárez Guerrero de la Universidad de Valencia.
            </p>
          </div>
          <Navigation
            prev="https://fundacionmohme.org/especiales/memoria-2024/observatorio-universitario-medios"
            textPrev="2.2 Observatorio Universitario de Medios"
            next="https://fundacionmohme.org/especiales/memoria-2024/#educacion"
            textNext="3. Eje Educación y Ciudadanía"
          />
        </div>
      </div>
    </section>
  );
};

export default CulturaDigital;
